import cloneDeep from 'lodash/cloneDeep';
import { SearchTaskSort, SearchElementDateRange, SearchTaskFilter } from '@askporter/client-grieg-lyric';
import { TaskState } from '../types';

/**
 * Transforms state into object suitable for POST request
 * @param filter - object containing filters from state
 *
 * @returns object containing transformed filters
 */
export const generateTaskSearchFilters = (filter: TaskState['search']['filter']): Partial<SearchTaskFilter> => {
  const filters: SearchTaskFilter = cloneDeep(filter);

  // check other filters and remove any empties
  Object.keys(filter).forEach((key) => {
    const typedKey = key as keyof SearchTaskFilter;
    // check for empty arrays
    if (Array.isArray(filters[typedKey])) {
      const arrayFilter = filters[typedKey] as Array<string>;
      if (arrayFilter.length < 1) delete filters[typedKey];
    }

    // check for date types with both elements (before & after) missing
    else if (
      typedKey !== 'actionOn' &&
      filters[typedKey] &&
      'before' in filters[typedKey] &&
      'after' in filters[typedKey]
    ) {
      const dateFilter = filters[typedKey] as SearchElementDateRange;
      if (!dateFilter.before && !dateFilter.after) delete filters[typedKey];
    }
  });

  return filters;
};

export const taskStateDefaults = (): TaskState => {
  const defaults: TaskState = {
    search: {
      extendedMetadataStats: [],
      freeText: '',
      sort: SearchTaskSort.Recommended,
      page: 1,
      filter: {
        created: {
          before: undefined,
          after: undefined,
        },
        resolutionDueDate: {
          before: undefined,
          after: undefined,
        },
        resolutionDueDateTime: {
          before: undefined,
          after: undefined,
        },
        responseDueDateTime: {
          before: undefined,
          after: undefined,
        },
        linkedAsset: [],
        linkedUser: [],
        assignedTeam: [],
        assignedUser: [],
        assignedTo: [],
        statusType: ['OPEN'],
        priority: [],
        status: [],
        taskType: [],
        escalationStatus: [],
      },
      oboUser: undefined,
    },
    listScrollPos: 0,
    isSearchEnabled: true,
    hasUserSelectedSort: false,
  };

  return defaults;
};
